import styled from 'styled-components';
import { recognizeReferencePoint } from '../../../../functions/utils/recognizeReferencePoint';
import { Dropdown } from '../../Dropdown';
import { DropdownContentContainer } from '../../DropdownContentContainer';
import { DropdownContentItem } from '../../DropdownContentItem';
import { PropertyIconButton } from '../../PropertyIconButton';
import { NumberInput } from '../../baseInputs/NumberInput';
import { useScene } from '../../../../context/sceneContext';

export const PositionInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData(
    {
      position: undefined,
      left: undefined,
      top: undefined,
      bottom: undefined,
      right: undefined,
    },
    'props.class'
  );

  const updateValue = (key: string, value?: string | number) =>
    scene.updateSelectedElementsData({ [key]: value }, 'props.class', 'positionInput');

  const referencePoint = recognizeReferencePoint(data);
  const getReferenceIconRotation = () => {
    if (referencePoint.y === 'top' && referencePoint.x === 'left') return '90deg';
    if (referencePoint.y === 'top' && referencePoint.x === 'right') return '180deg';
    if (referencePoint.y === 'bottom' && referencePoint.x === 'left') return '0deg';
    if (referencePoint.y === 'bottom' && referencePoint.x === 'right') return '270deg';

    return '90deg';
  };

  return (
    <Row>
      <NumberInput
        label="X"
        value={data[referencePoint.x || 'left']}
        onChange={(newValue) => updateValue(referencePoint.x || 'left', newValue)}
        precision={0}
        isDisabled={data.position === 'relative'}
      />
      <NumberInput
        label="Y"
        value={data[referencePoint.y || 'top']}
        onChange={(newValue) => updateValue(referencePoint.y || 'top', newValue)}
        precision={0}
        isDisabled={data.position === 'relative'}
      />
      <SideButtonContainer>
        {data.position === 'absolute' && (
          <Dropdown
            trigger={<PropertyIconButton iconClassName="icon-axis" style={{ rotate: getReferenceIconRotation() }} />}
            children={
              <DropdownContentContainer>
                <DropdownContentItem
                  onClick={() =>
                    scene.updateSelectedElementsData(
                      {
                        top: 0,
                        left: 0,
                        bottom: undefined,
                        right: undefined,
                      },
                      'props.class',
                      'positionInput'
                    )
                  }
                >
                  Top Left
                  <i className="icon-axis" style={{ marginLeft: '10px', rotate: '90deg' }} />
                </DropdownContentItem>
                <DropdownContentItem
                  onClick={() =>
                    scene.updateSelectedElementsData(
                      {
                        top: 0,
                        left: undefined,
                        bottom: undefined,
                        right: 0,
                      },
                      'props.class',
                      'positionInput'
                    )
                  }
                >
                  Top Right
                  <i className="icon-axis" style={{ marginLeft: '10px', rotate: '180deg' }} />
                </DropdownContentItem>
                <DropdownContentItem
                  onClick={() =>
                    scene.updateSelectedElementsData(
                      {
                        top: undefined,
                        left: 0,
                        bottom: 0,
                        right: undefined,
                      },
                      'props.class',
                      'positionInput'
                    )
                  }
                >
                  Bottom Left
                  <i className="icon-axis" style={{ marginLeft: '10px' }} />
                </DropdownContentItem>
                <DropdownContentItem
                  onClick={() =>
                    scene.updateSelectedElementsData(
                      {
                        top: undefined,
                        left: undefined,
                        bottom: 0,
                        right: 0,
                      },
                      'props.class',
                      'positionInput'
                    )
                  }
                >
                  Bottom Right
                  <i className="icon-axis" style={{ marginLeft: '10px', rotate: '270deg' }} />
                </DropdownContentItem>
              </DropdownContentContainer>
            }
            horizontalAlign="right"
          />
        )}

        <PropertyIconButton
          iconClassName="icon-position-lock"
          isActive={data.position !== 'absolute'}
          onClick={() =>
            data.position !== 'absolute'
              ? scene.updateSelectedElementsData(
                  {
                    position: 'absolute',
                    top: undefined,
                    bottom: undefined,
                    left: undefined,
                    right: undefined,
                  },
                  'props.class',
                  'positionInput'
                )
              : scene.updateSelectedElementsData(
                  {
                    position: 'relative',
                    top: undefined,
                    bottom: undefined,
                    left: undefined,
                    right: undefined,
                  },
                  'props.class',
                  'positionInput'
                )
          }
        />
      </SideButtonContainer>
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;

  gap: 5px;
`;

const SideButtonContainer = styled.div`
  min-width: 60px;
  display: flex;
  justify-content: flex-end;
  gap: 5px;
`;
